<script lang="ts" setup>
withDefaults(
  defineProps<{
    direction?: 'left' | 'right'
  }>(),
  {
    direction: 'left',
  },
)
</script>

<template>
  <ButtonBase class="navigation">
    <template #before>
      <Icon :name="`mini-arrow-slider-${direction}`" />
    </template>
    {{ '' }}
  </ButtonBase>
</template>

<style lang="scss" scoped>
.navigation {
  left: auto;
  right: auto;

  @include fluid-ts-ds(--pv, 12px, 18px);
  @include fluid-ts-ds(--ph, 12px, 18px);

  svg {
    transform: none;
  }
}
</style>
